import {ChangeDetectorRef, Component, Input} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {IconButtonType} from "../../buttons/icon-button/icon-button";

@Component({
    selector: "woa-password-field",
    templateUrl: "./password-field.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: PasswordFieldComponent, multi: true}]
})
export class PasswordFieldComponent extends AbstractField {
    @Input() autocomplete: "current-password" | "new-password";
    @Input() maxlength: string = "20";

    IconButtonType = IconButtonType;

    showPassword: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    toggleShowPassword() {
        this.showPassword = !this.showPassword;
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/password-field/password-field.component.ts